function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 30C0 13.431 13.431 0 30 0h381c16.569 0 30 13.431 30 30v153a5 5 0 01-5 5H30c-16.569 0-30-13.431-30-30V30z",
  fill: "#F7F8F9",
  opacity: 0.95
});

function SvgHomeLongDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 188,
    viewBox: "0 0 441 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQxIiBoZWlnaHQ9IjE4OCIgdmlld0JveD0iMCAwIDQ0MSAxODgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBvcGFjaXR5PSIuOTUiPgogICAgICAgIDxwYXRoIGQ9Ik0wIDMwQzAgMTMuNDMxIDEzLjQzMSAwIDMwIDBoMzgxYzE2LjU2OSAwIDMwIDEzLjQzMSAzMCAzMHYxNTNhNSA1IDAgMDEtNSA1SDMwYy0xNi41NjkgMC0zMC0xMy40MzEtMzAtMzBWMzB6IiBmaWxsPSIjRjdGOEY5Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgHomeLongDrive as ReactComponent };